import bankStatements from './bank-statements.json';
import cashDocuments from './cash-documents.json';
import contragentsDebts from './contragents-debts.json';
import expenseReports from './expense-reports.json';
import vatReports from './vat-reports.json';
const bank = {
   'bank-statements': bankStatements,
   'expense-reports': expenseReports,
   'cash-documents': cashDocuments,
   'vat-reports': vatReports,
   'contragents-debts': contragentsDebts,
};
export default bank;
